// extracted by mini-css-extract-plugin
export default {"fullView":"page-module--full-view--360ad","textContainer":"page-module--text-container--bf763","backgroundVideo":"page-module--background-video--95893"};